// extracted by mini-css-extract-plugin
export default {"Blur":"loader_Blur__xsddL","Loading":"loader_Loading__DcHO2","loading":"loader_loading__-DOPm"};